import {Injectable} from "@angular/core";
import {NGXLogger} from "ngx-logger";
import {LoadScriptService} from "../../../projects/shared/src/lib/load-script.service";
import {v4 as uuidv4} from 'uuid';
import {RestClientService} from "../../../projects/shared/src/lib/rest-client.service";
import {map} from "rxjs/operators";

declare const TossPayments: any;

@Injectable()
export class AutoBillingService {
  constructor(private log: NGXLogger,
              private restClient: RestClientService,
              private loadScriptService: LoadScriptService) {
  }

  getBillingInfo() {
    return this.restClient.get('/users/auto-billing')
      .pipe(map((response: any) => {
        return response.data;
      }))
  }

  requestBillingKey(method: 'CARD' | 'TRANSFER', email: string) {
    this.loadScriptService.loadScript('https://js.tosspayments.com/v2/standard')
      .onload = () => {
      const clientKey = "test_ck_1GKNbdOvk5rkyYAYOz3n07xlzmj6";
      const customerKey = uuidv4()
      const tossPayments = TossPayments(clientKey);

      const payment = tossPayments.payment({customerKey});
      payment.requestBillingAuth({
        method: method,
        successUrl: window.location.origin + "/toss/auto",
        failUrl: window.location.origin + "/toss/auto",
        customerEmail: email,
        customerName: email.split('@')[0],
      })
    }
  }

  registerBillingKey(customerKey: string, authKey: string) {
    return this.restClient.post('/users/auto-billing', {customerKey, authKey})
      .pipe(map((response: any) => {
        return response.data;
      }))
  }

  deleteBillingKey() {
    return this.restClient.delete('/users/auto-billing')
  }
}
